module.exports = __webpack_public_path__ + "static/left_background-3d140dd77ff59a7c0726a1bdc5404dfe.png";